export const TextEffectsLetterPressViewerType =
  'wixui.TextEffectsLetterPress' as const;
export const TestIds = {
  viewer: {
    container: 'TextEffectsLetterPress-container',
    text: 'TextEffectsLetterPress-text',
  },
} as const;
